export const recipeMessages = {
	closeRecipeFilterLabel: {
		id: 'recipesCloseFilterLabel',
		defaultMessage: 'Close recipe {filter} filter',
	},
	openRecipeFilterLabel: {
		id: 'recipesOpenFilterLabel',
		defaultMessage: 'Open recipe {filter} filter',
	},
	recipeListLabel: {
		id: 'recipesListLabel',
		defaultMessage: 'Recipes list',
	},
	recipeFiltersLabel: {
		id: 'recipesFiltersLabel',
		defaultMessage: 'Recipe filters',
	},
	instructionListLabel: {
		id: 'recipesInstructionListLabel',
		defaultMessage: 'Step by step recipe instruction',
	},
	filterCriteriaListLabel: {
		id: 'recipesFilterCriteriaListLabel',
		defaultMessage: 'Recipe filter criteria options',
	},
	whereToBuy: {
		id: 'recipesWhereToBuy',
		defaultMessage: 'Where to buy',
	},
	tagList: {
		id: 'recipesTagList',
		defaultMessage: 'Recipe tag list',
	},
	ingredients: {
		id: 'recipesIngredients',
		defaultMessage: 'Ingredients',
	},
	method: {
		id: 'recipesMethod',
		defaultMessage: 'Method',
	},
	productRecipes: {
		id: 'recipesProductRecipes',
		defaultMessage: '{product} recipes',
	},
	moreProductRecipes: {
		id: 'recipesMoreProductRecipes',
		defaultMessage: 'More {product} recipes',
	},
	allProductRecipes: {
		id: 'recipesAllProductRecipes',
		defaultMessage: 'All {product} recipes',
	},
	serves: {
		id: 'recipesServes',
		defaultMessage: 'Serves',
	},
	people: {
		id: 'recipesPeople',
		defaultMessage:
			'{servesCount} {servesCount, plural, one {person} other {people} }',
	},
	time: {
		id: 'recipesTime',
		defaultMessage: 'Time',
	},
	totalTime: {
		id: 'recipesTotalTime',
		defaultMessage: 'Total Time',
	},
	difficulty: {
		id: 'recipesDifficulty',
		defaultMessage: 'Difficulty',
	},
	category: {
		id: 'recipesCategory',
		defaultMessage: 'Category',
	},
	cuisine: {
		id: 'recipesCuisine',
		defaultMessage: 'Cuisine',
	},
	easy: {
		id: 'recipesEasy',
		defaultMessage: 'Easy',
	},
	medium: {
		id: 'recipesMedium',
		defaultMessage: 'Medium',
	},
	hard: {
		id: 'recipesHard',
		defaultMessage: 'Hard',
	},
	loading: {
		id: 'recipesLoading',
		defaultMessage: 'Loading...',
	},
	loadMore: {
		id: 'recipesLoadMore',
		defaultMessage: 'Load More',
	},
	showingNumRecipes: {
		id: 'recipesShowingNumRecipes',
		defaultMessage:
			'Showing {recipeCount} {recipeCount, plural, one {recipe} other {recipes} }',
	},
	abbreviatedHours: {
		id: 'recipesAbbreviatedHours',
		defaultMessage: 'hrs.',
	},
	abbreviatedMins: {
		id: 'recipesAbbreviatedMins',
		defaultMessage: 'mins.',
	},
	noResults: {
		id: 'recipesNoResults',
		defaultMessage: 'There are no recipes that match your filter criteria',
	},
};
